import * as React from 'react';

import { translate } from '~l10n/client';

import NoResultsIcon from '../../../../../../shared/icons/NoResultsIcon';

export function LegacyNoReport() {
  return (
    <div className="no-reports-found-container">
      <NoResultsIcon className="no-reports-found-icon" />
      <span className="no-reports-found-large-text">
        {translate('No Reports Found')}
      </span>
    </div>
  );
}
